<template>
  <div>
    <l-legend-color-bar
      v-if="legend"
      :title="layer.alias"
      :config="legendOptions"
      :active="isVisible"
    />
    <l-control-identify
      v-if="isVisible"
      :type="layer.identify.type"
      :fields="layer.identify.fields"
      :active="layerIdentify"
    />
  </div>
</template>
<script>
import LMapLegendColorBar from "@/components/map/LMapLegendColorBar";
import LControlIdentify from "@/components/map/LControlIdentify";

export default {
  components: {
    "l-legend-color-bar": LMapLegendColorBar,
    "l-control-identify": LControlIdentify
  },
  props: {
    identify: {
      type: Boolean,
      default: false
    },
    layer: {
      type: Object, // {alias: '', active: '', url: '', wmsOptions:{}}
      required: true
    },
    legend: {
      type: Boolean,
      required: false,
      default: false
    },
    legendOptions: {
      type: Object,
      required: false,
      default() {
        return {
          format: "image/png",
          transparent: true
        };
      }
    },
    loadOnInit: {
      type: Boolean,
      required: false,
      default: true
    },
    showInLayerSwitcher: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      groupedLayerSwitcher: this.$parent.groupedLayersControl,
      sideBySideLayers: this.$parent.sideBySideLayersControl,
      map: this.$parent.mapObj,
      layerIdentify: this.identify,
      wmsLayer: {},
      wmsSecondaryLayer: {}
    };
  },
  computed: {
    isVisible() {
      return this.layer.url !== "" && this.layer.active !== "";
    },
    isSideBySideControlActive() {
      return Object.keys(this.sideBySideLayers).length > 0;
    }
  },
  updated() {
    // Clear map before loading another layer
    this.removeLayer();
    this.loadWmsLayer();
  },
  destroyed() {
    this.removeLayer();
  },
  mounted() {
    if (this.isVisible) {
      this.init();
    }
  },
  methods: {
    init() {
      // this.loadWmsLayer();
    },
    loadWmsLayer() {
      this.wmsLayer = L.tileLayer.wms(this.layer.url, this.layer.wmsOptions);
      this.wmsLayer.addTo(this.map);
      if (this.layer.hasFuture) {
        //compare layer and future projection
        this.loadComparisonLayer(this.layer.urlFuture);
      }
      if (this.showInLayerSwitcher) {
        this.groupedLayerSwitcher.addOverlay(
          this.wmsLayer,
          this.layer.wmsOptions.alias,
          this.layer.group
        );
      }
    },
    loadComparisonLayer(compareLayerUrl) {
      this.wmsSecondaryLayer = L.tileLayer
        .wms(compareLayerUrl, this.layer.wmsOptions)
        .addTo(this.map);

      this.sideBySideLayers = L.control.sideBySide(
        this.wmsLayer,
        this.wmsSecondaryLayer,
        {
          thumbSize: 160,
          padding: 0
        }
      );
      this.sideBySideLayers.addTo(this.map);
    },
    removeLayer() {
      if (Object.keys(this.wmsLayer).length > 0) {
        this.map.removeLayer(this.wmsLayer);
      }
      if (Object.keys(this.wmsSecondaryLayer).length > 0) {
        this.sideBySideLayers.remove(); //remove sidebyside control
        this.map.removeLayer(this.wmsSecondaryLayer);
        this.wmsSecondaryLayer = {};
      }
    }
  }
};
</script>
<style scoped></style>
